import gql from 'graphql-tag';

export const DETACH_FILE = gql`
  mutation detatchFile($id: Int!, $assetId: String!) {
    directory {
      detachFile(id: $id, assetId: $assetId)
    }
  }
`;
